import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


// Basic Editor Configuration
const basicConfig = {
  toolbar: ["bold", "italic", "paragraph", "fontSize", "fontColor", "fontBackgroundColor", 
            "alignment:left", "alignment:center", "alignment:right", "alignment:justify"],
  fontSize: {options: [10, 12, 14, "default", 18, 20, 24, 28, 32, 36],},
  alignment: {options: ["left", "center", "right", "justify"],},
};

// Advanced Editor Configuration (for images)
const advancedConfig = {
  toolbar: ["bold", "italic", "imageUpload", "fontSize", "fontColor", "fontBackgroundColor", 
            "alignment:left", "alignment:center", "alignment:right", "alignment:justify"],
  image: {
    toolbar: ["imageTextAlternative", "imageStyle:full", "imageStyle:side"]
  },
  simpleUpload: {
    uploadUrl: "http://localhost:8080/api/upload-image", // Updated for your server endpoint
    headers: {
      'X-CSRF-TOKEN': 'CSRF-Token', // Add any required CSRF token here
    },
    withCredentials: true
    
  },
  fontSize: {options: [10, 12, 14, "default", 18, 20, 24, 28, 32, 36],},
  alignment: {options: ["left", "center", "right", "justify"],},
};

function EditorComponent({ isAdvanced = false, onChange, onReady, data }) {
  return (
    <div>
      <CKEditor
        editor={ClassicEditor}
        config={isAdvanced ? advancedConfig : basicConfig}
        data={data}
        onReady={(editor) => {
          if (onReady) onReady(editor);
          //console.log("Editor is ready to use!", editor);
        }}
        onChange={(event, editor) => {
          //const editorData = editor.getData();
          onChange(event, editor); // Pass the event and editor for further processing
        }}
      />
    </div>
  );
}

export default EditorComponent;
